import { theme } from '@codametrix/themes/chakra/biome';

export const styles = () => ({
  text: {
    ...theme.textStyles['h4'],
    color: theme.colors.text['highEmphasis']
  }
});
